// Environment configuration for different deployment scenarios
export const isDev: boolean = process.env.REACT_APP_DEV_MODE === 'true'

const getApiBaseUrl = (): string => {
    // Check if we're in dev mode
    if (isDev) {
        return process.env.REACT_APP_DEV_API_BASE || '/api/v1'
    } else {
        const currentHost = window.location.hostname;
        const currentProtocol = window.location.protocol

        const isIPAccess = /^\d+\.\d+\.\d+\.\d+$/.test(currentHost);

        if(isIPAccess){
            return `${currentProtocol}//${currentHost}/api/v1`
        } else {
            return process.env.REACT_APP_PROD_API_BASE || 'https://api.centese.app/api/v1'
        }
    }
  };
  
  export const API_BASE_URL = getApiBaseUrl();
  